module.exports = __webpack_public_path__ + "static/media/videos_tile.56802ed8.jpg";